module.exports = __webpack_public_path__ + "static/media/V65-label.300b7e22.png";